export default __webpack_public_path__ + "static/media/N.a23e53ac.png";